function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useContext, useState } from 'react';
import cn from 'classnames';
import { string, number, func, any } from 'prop-types';
import FormContext from '../../context/FormContext';
import FormGroupContext from '../../context/FormGroupContext';
/**
 * FormRange component.
 */

var FormRange = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      topLabel = _ref.topLabel,
      rightLabel = _ref.rightLabel,
      leftLabel = _ref.leftLabel,
      min = _ref.min,
      max = _ref.max,
      className = _ref.className,
      onChange = _ref.onChange,
      step = _ref.step,
      defaultValue = _ref.defaultValue;

  var _useContext = useContext(FormGroupContext),
      inputId = _useContext.inputId,
      feedbackId = _useContext.feedbackId;

  var _useContext2 = useContext(FormContext),
      inverted = _useContext2.inverted,
      defaultValues = _useContext2.defaultValues,
      validateInput = _useContext2.validateInput;

  var _useState = useState(defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || 0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(evt) {
    var rangeValue = evt.target.value;
    setValue(rangeValue);

    if (onChange) {
      onChange(rangeValue);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn("form-range text-center", className, !topLabel && 'd-flex', inverted && 'form-range--inverted')
  }, topLabel && /*#__PURE__*/React.createElement("div", {
    className: "text-center pb-xxs"
  }, topLabel), leftLabel && /*#__PURE__*/React.createElement("span", {
    className: 'form-range__label'
  }, leftLabel), /*#__PURE__*/React.createElement("input", {
    autoComplete: "off",
    id: inputId,
    type: "range",
    className: "form-range__input",
    min: min,
    max: max,
    onChange: validateInput ? function (evt) {
      return validateInput(evt, handleChange);
    } : handleChange,
    ref: ref,
    step: step,
    name: name,
    value: value || min,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-describedby": feedbackId
  }), rightLabel && /*#__PURE__*/React.createElement("span", {
    className: 'form-range__label'
  }, rightLabel));
});
FormRange.displayName = 'FormRange';
FormRange.defaultProps = {
  defaultValue: null,
  topLabel: null,
  leftLabel: null,
  rightLabel: null,
  className: null,
  min: 1,
  max: 10,
  onChange: null,
  step: 1
};
FormRange.propTypes = process.env.NODE_ENV !== "production" ? {
  /** defaultValue of the input */
  defaultValue: any,

  /** Name to identify the input */
  name: string.isRequired,

  /** Additional class names to add to the component root. */
  className: string,

  /** Left Label of the range */
  topLabel: string,

  /** Left Label of the range */
  leftLabel: string,

  /** Right Label of the range */
  rightLabel: string,

  /** Minimum value of the range */
  min: number,

  /** Maximum value of the range */
  max: number,

  /** Additional onChange */
  onChange: func,

  /** Step attribue this sets the granularity that the value must adhere to */
  step: number
} : {};
export default FormRange;